(ns common.agency-selection-ocp.view
  (:require ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-query]]
            [common.resource.query.user :refer [user-query]]
            [common.util :refer [spread-obj]]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

;; This can be refactored when the auth code uses TSQ
(rf/reg-event-fx ::click-row
  (fn [_ [_ {:keys [agencyId]}]]
    {:fx [[:dispatch [:ocp/close]]
          [:dispatch [:resource.user/remove-last-viewed-advertiser-id]]
          [:async-flow {:id :click-row
                        :first-dispatch [:resource.auth/switch-agency agencyId]
                        :rules [{:when :seen?
                                 :events :resource.auth/switched-agency
                                 :halt? true
                                 :dispatch [:router/navigate-home]}]}]]}))

(defui format-name
  [{:keys [agencyName agencyId]}]
  (let [{:keys [agency-id]} (use-subscribe [:url-context])]
    ($ Stack
       {:direction "row"
        :justifyContent "space-between"
        :alignItems "center"
        :spacing 1
        :sx #js {:width "100%"}}
       ($ :span agencyName)
       (when (= agency-id agencyId)
         ($ Icon {:color "success"} "check")))))

(def columns
  #js [#js {:type "string"
            :field "agencyName"
            :headerName "Name"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:agencyName row))
            :renderCell (fn [^js params]
                          ($ format-name (.-row params)))
            :flex 1
            :sortable true}])

(def Toolbar
  (uix/as-react
   (fn [_]
     ($ dg/grid-toolbar {:sx #js {:px 1.25
                                  :py 2.5
                                  ".MuiFormControl-root" #js {:pb 0
                                                              :flex 1}}}))))

(defocp switch-agency-ocp :switch-agency-ocp/view
  {:position :left
   :disable-padding true}
  [_]
  (let [{:keys [data isFetching]} (use-query (user-query))

        get-row-id (uix/use-callback (fn [row]
                                       (:agencyId row))
                                     [])

        on-row-click (uix/use-callback
                      (fn [^js o ^js _event]
                        (rf/dispatch [::click-row (.-row o)]))
                      [])]
    ($ ocp
       {:title "Select an Agency"}
       ($ DataGridPremium
          {:columns columns
           :loading isFetching
           :rows (to-array (:roles data))
           :getRowId get-row-id
           :onRowClick on-row-click

           :disableColumnResize true
           :disableColumnMenu true
           :hideFooter true

           :initialState #js {:sorting #js {:sortModel #js [#js {:field "agencyName" :sort "asc"}]}}

           :slots #js {:toolbar Toolbar}
           :slotProps #js {:baseTextField (spread-obj dg/grid-toolbar-outlined-input
                                                      #js {:autoFocus true})}

           :sx #js {".MuiDataGrid-columnHeader .MuiBadge-badge" #js {:display "none"}}}))))
